module.exports = __webpack_public_path__ + "img/BNB.b4e96fd7.svg";